import { gameGeneratorQueryOptions } from "@/api/fapinstructor/game-generator/get-game-generator";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { GameGeneratorInfoCard } from "./-components/game-generator-info-card";
import { GameBuilderForm } from "./-components/game-generator-form";
import {
  loadGameGeneratorSession,
  storeGameGeneratorSession,
} from "@/store/game-generator-session";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId",
)({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      gameGeneratorQueryOptions({
        gameGeneratorId: opts.params.gameGeneratorId,
      }),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { gameGeneratorId } = Route.useParams();
  const gameGenerator = Route.useLoaderData();
  const gameGeneratorSession = loadGameGeneratorSession(gameGeneratorId);
  const gameGeneratorConfig = gameGeneratorSession ?? gameGenerator.config;

  return (
    <>
      <GameGeneratorInfoCard gameGenerator={gameGenerator} />
      <GameBuilderForm
        initialValues={gameGeneratorConfig}
        gameGenerator={gameGenerator}
        onGenerate={async (values) => {
          // A user can override game generator settings, we don't want to
          // permanently persist this so we store this in session state.
          storeGameGeneratorSession(gameGeneratorId, values);
          navigate({
            to: "/play/game-generator/$gameGeneratorId",
            params: { gameGeneratorId },
          });
        }}
      />
    </>
  );
}
